export default __webpack_public_path__ + "static/media/logo.24716738.svg";